const tooltip = {
  sphere: "Refers to the amount of spherical error for your eyes, measured in quarters and proceeded by a (+) or (-).",
  cylinder: "Describes astigmatism, a refractive error that causes distorted and blurred vision, measured in quarters and proceeded by a (+) or (-).",
  axis: "Indicates the orientation of astigmatism, measured in degrees 1 to 180.",
  pupillary: 'It is the distance from the center of one pupil to the center of the other pupil measured in mm.',
}

export default tooltip;